/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-27 13:33:12
 * @LastEditors: hongye
 * @LastEditTime: 2026-01-14 10:04:44
 */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { requestFail, requestError, dataType } from '@/utils'
import { useAuthStore, useSettingStore } from '@/store'
import LangType from '@/utils/enums/LangType'
import { objKeySort, deleteNullKey, getTimezoneOffset } from '@/utils/index'
import { Md5 } from 'ts-md5'
import HTTP_CODE_STATUS from '@/utils/httpCode'
import { message } from 'ant-design-vue'
const { VITE_APP_API_BASE_URL, VITE_APP_SIGNKEY, VITE_TMP_CONTROL_TOWER_SIGNKEY, NODE_ENV } = import.meta.env
export const getToken = () => {
  const authStore = useAuthStore()
  return authStore?.token
}

/**获取验签 */
const getTmpSign = (config: AxiosRequestConfig, _time: any) => {
  if (dataType(config.data) === 'formdata') return
  /**删除空值 */
  let params = deleteNullKey(config.data ? JSON.parse(config.data) : {})
  if (config.method === 'get') params = config.params ?? {}
  /**排序 */
  params = objKeySort(params)
  const reg = new RegExp('"', 'g')
  const reg2 = new RegExp(`'\''`, 'g')

  const key = `${JSON.stringify(params)}&ts=${_time}&signKey=${config.url?.indexOf('tcsapi') !== -1 ? VITE_TMP_CONTROL_TOWER_SIGNKEY : VITE_APP_SIGNKEY
    }`
    .replaceAll(reg, '')
    .replace(reg2, '')
  return Md5.hashStr(key).toUpperCase()
}
const axiosInstance = axios.create({
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  baseURL: NODE_ENV !== 'production' ? localStorage.getItem('baseApi') || VITE_APP_API_BASE_URL : VITE_APP_API_BASE_URL
})
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const { locale } = useSettingStore()
    const _time = new Date().getTime()
    if (config.method === 'get') {
      const data = config.params || {}
      config.data = JSON.stringify(data)
    }
    Object.assign(config.headers!, {
      authToken: getToken(),
      sysCode: 'WEB',
      ts: _time,
      language: LangType[locale],
      langType: LangType[locale],
      tmpSign: getTmpSign(config, _time),
      timezone: getTimezoneOffset()
    })
    return config
  },
  (error) => {
    return error
  }
)
// 响应拦截
axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => {
    const { data } = res
    if (res.status === 200) {
      const SUCCESS_CODES = [HTTP_CODE_STATUS.SUCCESS, ...HTTP_CODE_STATUS.ALERT]
      if (data?.code && !SUCCESS_CODES.includes(data.code)) requestFail(data)
    } else {
      message.error(data.msg)
    }
    return res
  },
  (err: AxiosError) => {
    requestError(err)
  }
)
export default axiosInstance
